import React from "react";
import { Box, Grid } from "@mui/material";
import AuthLogin from "./LoginPage";

function SignIn() {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Grid container sx={{ flex: 1 }}>
        <Grid item xs={false} sm={4} md={6}>
          <div className="flex items-center justify-between">
            <img
              src={"/assets/icons/invoice-logo.svg"}
              alt="Logo"
              className="ml-4 mt-4"
            />
          </div>
          <Box
            component="img"
            className="w-full mt-2"
            sx={{
              height: 800,
              maxHeight: { xs: 200, md: 467 },
              maxWidth: { xs: 800, md: 1150 },
              objectFit: "cover",
            }}
            src="/assets/login-bg.svg"
          />
        </Grid>
        <Grid
          item
          sm={8}
          md={6}
          container
          justifyContent="center"
          alignItems="center"
        >
          <Grid item sm={8} md={7}>
            <AuthLogin />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SignIn;
